import { Typography } from '@mui/material';
import { Voucher, VoucherStatus } from 'models';
import { expireSoon, getDefaultDateFormat } from 'helpers/date';
import { partnerDetails } from 'constants/partnerDetails';
import VoucherState from 'components/VoucherState';
import ImageWithLoader from 'components/ImageWithLoader';

import {
  StyledButton,
  StyledCard,
  Content,
  MediaWrap,
  Text,
  SurprisePerkFlash,
  ThirdPartyBox,
} from './VoucherCard.styles';

export interface VoucherCardProps {
  voucher: Voucher;
  onClick: (voucher: Voucher) => void;
}

interface CardContent {
  text: string;
  info: string;
}

const VoucherCard = ({ voucher, onClick }: VoucherCardProps) => {
  const { imageUrl, title, redemptionCode, date, surpriseVoucher, voucherType, status } = voucher;

  const isAlert = (status === 'active' && expireSoon(date).toString()) || '';
  const isThirdPartyPerk = voucherType !== 'Standard';
  const thirdPartyPartner = isThirdPartyPerk && partnerDetails[voucherType];

  const content: Record<VoucherStatus, CardContent> = {
    active: {
      text: redemptionCode ? 'Redemption Code' : 'Click for details',
      info: redemptionCode,
    },
    expired: {
      text: 'Expired on',
      info: getDefaultDateFormat(date),
    },
    redeemed: {
      text: 'Redeemed on',
      info: getDefaultDateFormat(date),
    },
  };

  const handleOnClick = () => onClick(voucher);

  const { text, info } = content[status];

  return (
    <StyledButton disabled={status !== 'active'} disableRipple onClick={handleOnClick}>
      <StyledCard>
        <Content status={status} alert={isAlert}>
          <Text variant="subtitle1">{title}</Text>
          <VoucherState status={status} date={date} />
        </Content>

        <MediaWrap surprise={`${surpriseVoucher}`}>
          {surpriseVoucher && (
            <SurprisePerkFlash>
              <Typography variant="h2">Surprise Perk</Typography>
            </SurprisePerkFlash>
          )}

          {thirdPartyPartner && (
            <ThirdPartyBox aria-label="Third Party Logo">
              <img alt={thirdPartyPartner.id} src={thirdPartyPartner.logo} />
            </ThirdPartyBox>
          )}

          <ImageWithLoader src={imageUrl} alt={title} />
        </MediaWrap>

        <Content status={status} alert={isAlert}>
          <Typography variant="subtitle1">{text}</Typography>
          <Text variant="subtitle1">{info}</Text>
        </Content>
      </StyledCard>
    </StyledButton>
  );
};

export default VoucherCard;
